import React from 'react';
export default function useSupportedLocalesNormalizer(supportedLocales) {
  return React.useMemo(function () {
    return (supportedLocales || ['en']).map(function (l) {
      return typeof l === 'string' ? l : l.code;
    });
  }, [supportedLocales]);
}